<template>
    <n-config-provider
        :theme="theme.naiveTheme"
        :theme-overrides="theme.naiveThemeOverrides"
        :locale="NaiveLocal.locale"
        :date-locale="NaiveLocal.dateLocale"
        class="h-full"
    >
        <naive-provider>
            <router-view />
        </naive-provider>
    </n-config-provider>
</template>

<script setup lang="ts">
import { subscribeStore, useThemeStore } from "@/store"
import { useGlobalEvents } from "@/composables"
import { setNaiveLocale } from "@/locales/i18n"
const theme = useThemeStore()
const NaiveLocal = setNaiveLocale()
subscribeStore()
useGlobalEvents()
</script>

<style scoped></style>
